import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

// material-ui components
import { withStyles } from '@material-ui/core/styles';

// core components
import Badge from 'Common/Badge/Badge.jsx';

import timelineStyle from './styles.jsx';

function TimelineLog({ ...props }) {
    const { classes, stories, simple } = props;
    const timelineClass =
        classes.timeline +
        ' ' +
        cx({
            [classes.timelineSimple]: simple,
        });
    return (
        <ul className={ timelineClass }>
            { stories.map((prop, key) => {
                const panelClasses =
                    classes.timelinePanel +
                    ' ' +
                    cx({
                        [classes.timelinePanelInverted]: prop.inverted,
                        [classes.timelineSimplePanel]: simple,
                    });
                const timelineBadgeClasses =
                    classes.timelineBadge +
                    ' ' +
                    classes[prop.badgeColor] +
                    ' ' +
                    cx({
                        [classes.timelineSimpleBadge]: simple,
                    });
                return (
                    <li
                        className={ classes.item }
                        key={ key }
                    >
                        { prop.badgeIcon ? (
                            <div className={ timelineBadgeClasses }>
                                <prop.badgeIcon className={ classes.badgeIcon }/>
                            </div>
                        ) : null }
                        <div className={ panelClasses }>
                            <div className='timeline-top-wrapper'>
                                { prop.title ? (
                                    <div className={ classes.timelineHeading }>
                                        <Badge color={ prop.titleColor }>{ prop.title }</Badge>
                                    </div>
                                ) : null }
                                { prop.footerTitle ? (
                                    <h6 className={ classes.footerTitle }>{ prop.footerTitle }</h6>
                                ) : null }
                                { prop.footer ? (
                                    <div className={ classes.timelineFooter }>{ prop.footer }</div>
                                ) : null }
                            </div>
                            { prop.footer && prop.body ? <hr className={ classes.footerLine }/> : null }
                            <div className={ classes.timelineBody }>{ prop.body }</div>
                        </div>
                    </li>
                );
            }) }
        </ul>
    );
}

TimelineLog.propTypes = {
    classes: PropTypes.object.isRequired,
    stories: PropTypes.arrayOf(PropTypes.object).isRequired,
    simple: PropTypes.bool,
};

export default withStyles(timelineStyle)(TimelineLog);



// WEBPACK FOOTER //
// ./src/common/TimelineLog/TimelineLog.jsx